module.exports = __webpack_public_path__ + "media/images/payment/3dmastercard-eb70b3ed714ce90dc93ce78f57ed2bba.png";